import { CircularProgress } from '@mui/material';
import { LOADING_LABEL } from '../constants';
import { LoadingLabel, LoadingRoot } from './styled';
import type { LoadingStateProps } from './types';

const LoadingState = ({ label = LOADING_LABEL }: LoadingStateProps) => (
  <LoadingRoot role="status" aria-live="polite" aria-busy="true">
    <CircularProgress size={28} />
    <LoadingLabel>{label}</LoadingLabel>
  </LoadingRoot>
);

export default LoadingState;
